import React from 'react';
import {
  Avatar,
  Box,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  InputAdornment,
  Paper,
  Snackbar,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import ContactSupportIcon from '@material-ui/icons/ContactSupport';
import DeleteSweepIcon from '@material-ui/icons/DeleteSweep';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import DescriptionIcon from '@material-ui/icons/Description';
import PersonIcon from '@material-ui/icons/Person';
import SendIcon from '@material-ui/icons/Send';
import ThumbUpOutlinedIcon from '@material-ui/icons/ThumbUpOutlined';
import ThumbDownOutlinedIcon from '@material-ui/icons/ThumbDownOutlined';
import { useCallback, useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import axios from 'src/utils/axios';
import { getUser, getToken, getTokenWs, getIpAddress } from 'src/utils/Common';
import { loadBaslandiJob } from 'src/utils/storage/StartWorkOrder';
import logger from 'src/utils/logger';

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    [theme.breakpoints.up('sm')]: {
      borderRadius: 16,
      height: '80vh',
    },
    [theme.breakpoints.down('xs')]: {
      borderRadius: 0,
      height: '100%',
      margin: 0,
      maxWidth: '100%',
      maxHeight: 'none'
    },
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    backgroundColor: '#fff'
  },
  dialogTitle: {
    padding: theme.spacing(2),
    backgroundColor: '#ffffff',
    borderBottom: '1px solid #e0e0e0',
  },
  dialogContent: {
    flex: 1,
    backgroundColor: '#f4f6f8',
    padding: theme.spacing(2),
    paddingTop: theme.spacing(4),
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
  },
  dialogActions: {
    padding: theme.spacing(1),
    backgroundColor: '#ffffff',
    borderTop: '1px solid #f0f0f0',
  },
  messageRow: {
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: theme.spacing(2),
    width: '100%',
  },
  messageRowAgent: {
    justifyContent: 'flex-start',
  },
  messageRowCustomer: {
    justifyContent: 'flex-end',
  },
  bubbleContainer: {
    maxWidth: '75%',
    [theme.breakpoints.down('xs')]: {
      maxWidth: '85%',
    },
    display: 'flex',
    flexDirection: 'column',
  },
  bubble: {
    position: 'relative',
    padding: theme.spacing(1.5),
    filter: 'drop-shadow(0px 1px 1px rgba(0,0,0,0.1))',
    overflow: 'visible',
  },
  bubbleAgent: {
    backgroundColor: '#ffffff',
    color: theme.palette.text.primary,
    borderRadius: '0px 12px 12px 12px !important',
    marginLeft: theme.spacing(1),
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: '-9px',
      width: 0,
      height: 0,
      borderTop: '10px solid #ffffff',
      borderLeft: '10px solid transparent',
    }
  },
  bubbleCustomer: {
    backgroundColor: '#ffffff',
    color: '#ffffff',
    borderRadius: '12px 0px 12px 12px !important',
    marginRight: theme.spacing(1),
    '& a': { color: '#fff', textDecoration: 'underline' },
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      right: '-9px',
      width: 0,
      height: 0,
      borderTop: '10px solid #ffffff',
      borderRight: '10px solid transparent',
    }
  },
  timeText: {
    display: 'block',
    marginTop: theme.spacing(1),
    textAlign: 'right',
    fontSize: '0.7rem',
    opacity: 0.8,
    lineHeight: 1
  },
  docPaper: {
    padding: theme.spacing(0.8),
    marginTop: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    backgroundColor: '#f9fafb',
    border: '1px solid #eee',
    '&:hover': { backgroundColor: '#f0f0f0' }
  },
  inputCapsule: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    borderRadius: 14,
    backgroundColor: '#f4f6f8',
    padding: '6px 6px 6px 12px',
    border: '1.5px solid transparent',
    transition: 'all 0.2s',
    '&:focus-within': {
      backgroundColor: '#fff',
      border: '1.5px solid #FF9800',
      boxShadow: '0 0 0 3px rgba(255, 152, 0, 0.08)'
    },
  },
  cleanInput: {
    backgroundColor: 'transparent !important', // Global beyazı ezer
    paddingTop: '0px !important', // Global padding-top: 5px'i ezer (Hizalama bozulmasın diye)
    fontWeight: 'normal !important' // Eğer bold olmasını istemiyorsanız bunu da ekleyin
  },
  typingDot: {
    width: 6,
    height: 6,
    borderRadius: '100%',
    backgroundColor: '#888383de',
    display: 'inline-block',
    animation: `$bounce 1.4s infinite ease-in-out`,
    margin: '0 2px'
  },
  '@keyframes bounce': {
    '0%, 80%, 100%': { transform: 'scale(0)' },
    '40%': { transform: 'scale(1)' }
  },
  typingContainer: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: theme.spacing(1),
  },
  quickWrap: {
    marginTop: 12,
    display: 'flex',
    flexWrap: 'wrap',
  },
  quickChip: {
    backgroundColor: '#E0F2F1',
    color: '#00695C',
    fontSize: '0.80rem',
    fontWeight: 500,
    borderRadius: 16,
    marginRight: 10,
    marginBottom: 10,
    '&:hover': {
      backgroundColor: '#B2DFDB',
    },
  },
  scrollToBottomBtn: {
    position: 'sticky',
    bottom: 16,
    alignSelf: 'flex-end',
    zIndex: 10,
    backgroundColor: '#FF9800',
    color: '#fff',
    width: 36,
    height: 36,
    boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
    '&:hover': {
      backgroundColor: '#F57C00',
    },
  },
}));

function TypingIndicator() {
  const classes = useStyles();
  return (
    <Box className={classes.typingContainer}>
      {[0, 0.2, 0.4].map((delay, i) => (
        <span
          key={i}
          className={classes.typingDot}
          style={{ animationDelay: `${delay}s` }}
        />
      ))}
    </Box>
  );
}

function TeknisyenKocuDialog({ open, onClose, fisNo, KUL_MODEL_KODU, KulModelKoduAciklama, isValidateReceipt, tasks }) {
  const classes = useStyles();
  const endRef = useRef(null);
  const contentRef = useRef(null);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));

  let user = getUser();
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [isTyping, setIsTyping] = useState(false);
  const [convId, setConvId] = useState(null);
  const [documentLoading, setDocumentLoading] = useState(null);
  const [isTokenLoading, setIsTokenLoading] = useState(false);
  const [showScrollBtn, setShowScrollBtn] = useState(false);
  const isNearBottomRef = useRef(true);
  const programmaticScrollRef = useRef(false);

  const [quickQuestionsData, setQuickQuestionsData] = useState([]);
  const [pendingQuickSend, setPendingQuickSend] = useState(false);
  const [feedbackData, setFeedbackData] = useState({ msgId: null, type: null, comment: '' });
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const WELCOME_MSG_ID = 'welcome_agent_msg';

  const nowHHmm = () =>
    new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

  const getAllConversations = () => {
    const data = localStorage.getItem('conversations');
    return data ? JSON.parse(data) : [];
  };

  const formatTime = isoString => {
    const date = new Date(isoString);
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  const getQuickQuestions = fisNo => {
    if (!fisNo) return [];

    const all = JSON.parse(localStorage.getItem('quickQuestionsByFis') || '{}');

    return all[String(fisNo)] || [];
  };

  const isTokenAboutToExpire = () => {
    const tokenRaw = localStorage.getItem("tk_token_info");
    if (!tokenRaw) return true;
    const objData = JSON.parse(tokenRaw);
    const exp = Number(objData.expiresAt);
    if (Number.isNaN(exp)) return true;
    return Date.now() > exp - 60000;
  };

  const getConversationByFisNo = useCallback(no => {
    const data = getAllConversations();
    return data.find(c => String(c.FisNo) === String(no)) || null;
  }, []);

  const saveConversation = useCallback((no, conv_id, soru, cevap, documents = [], msgId = null) => {
    const allConvs = getAllConversations();
    let existingConversation = allConvs.find(
      c => String(c.FisNo) === String(no)
    );

    if (!existingConversation) {
      existingConversation = {
        FisNo: no,
        conv_id: conv_id || null,
        KonusmaGecmisi: []
      };
      allConvs.push(existingConversation);
    }

    if (conv_id && !existingConversation.conv_id) {
      existingConversation.conv_id = conv_id;
    }

    if (soru || cevap) {
      existingConversation.KonusmaGecmisi.push({
        tarih: new Date().toISOString(),
        soru,
        cevap,
        documents,
        msgId: documents.msgId || null
      });
    }
    try {
      localStorage.setItem(
        'conversations',
        JSON.stringify(allConvs)
      );
    } catch (e) {
      localStorage.removeItem('conversations');
    }
  }, []);

  const refreshTokenIfNeeded = useCallback(() => {
    if (isTokenAboutToExpire()) {
      getNewToken();
    }
  }, []);

  const handleSend = useCallback(async () => {
    const urunData = Array.isArray(tasks?.tasks) ? tasks.tasks.filter(d => parseInt(d.FisNo) === parseInt(fisNo)) : loadBaslandiJob();

    const text = input.trim();
    if (!text) {
      return;
    }

    const modelText = urunData?.[0]?.MODEL ? (urunData?.[0]?.MODEL.length > 20 ? urunData?.[0]?.MODEL.slice(0, 25) + '…' : urunData?.[0]?.MODEL) : KulModelKoduAciklama || '';
    const combinedCustomerText = modelText ? `${text}\n(Ürün: ${modelText})` : text;

    const cMsg = {
      id: Date.now() + '_c',
      sender: 'customer',
      text: combinedCustomerText,
      time: nowHHmm()
    };
    setMessages(prev => [...prev, cMsg]);
    setInput('');

    setIsTyping(true);

    refreshTokenIfNeeded();
    const tokenRaw = localStorage.getItem("tk_token_info");
    const tokenInfo = tokenRaw ? JSON.parse(tokenRaw) : {};

    const data = {
      input: text,
      conv_id: convId,
      receiptNumber: fisNo,
      userModelCode: KUL_MODEL_KODU,
      UserId: user.UserId,
      isValidateReceipt: isValidateReceipt,
      accessToken: tokenInfo.accessToken
    };

    axios
      .post('/ChatWithProduct', data)
      .then(res => {
        const data = res?.data ?? {};
        const reply = data.Response;
        const newConvId = data.ConvId ?? null;
        const documents = data.Documents ?? [];
        const msgId = data.MsgId ?? null;

        if (newConvId && !convId) {
          setConvId(newConvId);
        }

        const aMsg = {
          id: Date.now() + '_a',
          sender: 'agent',
          text: reply,
          time: nowHHmm(),
          documents: documents,
          msgId: msgId
        };
        setMessages(prev => [...prev, aMsg]);

        saveConversation(fisNo, newConvId, combinedCustomerText, reply, documents, msgId);
      })
      .catch(ex => {
        const errMsg = {
          id: Date.now() + '_err',
          sender: 'agent',
          text: ex?.message || 'Bir hata oluştu.',
          time: nowHHmm()
        };
        setMessages(prev => [...prev, errMsg]);
      })
      .finally(() => {
        setIsTyping(false);
      });
  }, [tasks, fisNo, input, KulModelKoduAciklama, convId, KUL_MODEL_KODU, user.UserId, isValidateReceipt, saveConversation, refreshTokenIfNeeded]);

  // const handleSendStream = useCallback(async () => {
  //   const urunData = Array.isArray(tasks?.tasks)
  //     ? tasks.tasks.filter(d => parseInt(d.FisNo) === parseInt(fisNo))
  //     : loadBaslandiJob();

  //   const text = input.trim();
  //   if (!text) return;

  //   const modelText = urunData?.[0]?.MODEL
  //     ? (urunData?.[0]?.MODEL.length > 20 ? urunData?.[0]?.MODEL.slice(0, 25) + '…' : urunData?.[0]?.MODEL)
  //     : KulModelKoduAciklama || '';
  //   const combinedCustomerText = modelText ? `${text}\n(Ürün: ${modelText})` : text;

  //   const cMsg = {
  //     id: Date.now() + '_c',
  //     sender: 'customer',
  //     text: combinedCustomerText,
  //     time: nowHHmm()
  //   };
  //   setMessages(prev => [...prev, cMsg]);
  //   setInput('');
  //   setIsTyping(true);

  //   refreshTokenIfNeeded();
  //   const tokenRaw = localStorage.getItem('tk_token_info');
  //   const tokenInfo = tokenRaw ? JSON.parse(tokenRaw) : {};

  //   const reqData = {
  //     input: text,
  //     conv_id: convId,
  //     receiptNumber: fisNo,
  //     userModelCode: KUL_MODEL_KODU,
  //     UserId: user.UserId,
  //     isValidateReceipt: isValidateReceipt,
  //     accessToken: tokenInfo.accessToken
  //   };

  //   const streamMsgId = Date.now() + '_a';
  //   let streamMsgAdded = false;

  //   // İlk içerik geldiğinde typing indicator'ı kaldırıp bubble'ı içerikle birlikte ekle.
  //   // Boş bubble render'lanmasını önler.
  //   const addStreamMsg = (initialText = '', extraProps = {}) => {
  //     if (!streamMsgAdded) {
  //       streamMsgAdded = true;
  //       setMessages(prev => {
  //         const newMsg = {
  //           id: streamMsgId,
  //           sender: 'agent',
  //           text: initialText,
  //           time: nowHHmm(),
  //           documents: [],
  //           msgId: null,
  //           isStreaming: true,
  //           ...extraProps
  //         };
  //         // isTyping false'a çekmek için mesajı eklerken aynı anda güncelliyoruz.
  //         // isTyping ayrı bir state olduğu için burada direkt setIsTyping çağrısı gerekiyor,
  //         // React 18 otomatik batch'leyeceği için tek render'a düşer.
  //         return [...prev, newMsg];
  //       });
  //       setIsTyping(false);
  //     }
  //   };

  //   try {
  //     const baseUrl = process.env.REACT_APP_API_URL || '';
  //     const AuthToken = getToken();
  //     const AuthTokenWs = getTokenWs();
  //     const IpAddress = getIpAddress();
  //     const fetchResponse = await fetch(`${baseUrl}/ChatWithProductStream`, {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Accept': 'text/event-stream',
  //         'Authorization': 'Bearer ' + AuthToken,
  //         'SessionToken': AuthToken,
  //         'SessionTokenWs': AuthTokenWs,
  //         'IpAddress': IpAddress || '',
  //         'Auth-UserId': user ? user.UserId : ''
  //       },
  //       body: JSON.stringify(reqData)
  //     });

  //     if (!fetchResponse.ok) {
  //       throw new Error(`HTTP ${fetchResponse.status}`);
  //     }

  //     const reader = fetchResponse.body.getReader();
  //     const decoder = new TextDecoder();
  //     let buffer = '';
  //     let currentEventType = null;
  //     let streamedText = '';

  //     while (true) {
  //       const { done, value } = await reader.read();
  //       if (done) break;

  //       buffer += decoder.decode(value, { stream: true });
  //       const parts = buffer.split('\n');
  //       buffer = parts.pop();

  //       for (const line of parts) {
  //         if (line.trim() === '') {
  //           currentEventType = null;
  //           continue;
  //         }
  //         if (line.startsWith('event:')) {
  //           currentEventType = line.substring(6).trim();
  //           continue;
  //         }
  //         if (!line.startsWith('data:')) continue;

  //         // SSE spec: 'data:' sonrasındaki tek zorunlu boşluk (varsa) atlanır,
  //         // geri kalan boşluklar kelimelerin arasına yerleşmesi için korunur.
  //         const rawPayload = line.startsWith('data: ')
  //           ? line.substring(6)   // 'data: ...' → tek leading space atlanır
  //           : line.substring(5);  // 'data:...'  → olduğu gibi

  //         if (currentEventType === 'chunk') {
  //           streamedText += rawPayload;
  //           if (!streamMsgAdded) {
  //             // İlk chunk: typing indicator kalkar, bubble metinle birlikte eklenir
  //             addStreamMsg(streamedText);
  //           } else {
  //             const textSnapshot = streamedText;
  //             setMessages(prev =>
  //               prev.map(m => m.id === streamMsgId ? { ...m, text: textSnapshot } : m)
  //             );
  //           }
  //         } else if (currentEventType === 'final') {
  //           try {
  //             const finalData = JSON.parse(rawPayload.trim());
  //             const reply = finalData.Response;
  //             const newConvId = finalData.ConvId ?? null;
  //             const documents = finalData.Documents ?? [];
  //             const msgId = finalData.MsgId ?? null;

  //             if (newConvId && !convId) {
  //               setConvId(newConvId);
  //             }

  //             if (!streamMsgAdded) {
  //               // Chunk gelmeden direkt final geldi (quick question vb.): bubble tam metinle eklenir
  //               addStreamMsg(reply, { documents, msgId, isStreaming: false });
  //             } else {
  //               setMessages(prev =>
  //                 prev.map(m =>
  //                   m.id === streamMsgId
  //                     ? { ...m, text: reply, documents, msgId, time: nowHHmm(), isStreaming: false }
  //                     : m
  //                 )
  //               );
  //             }

  //             saveConversation(fisNo, newConvId, combinedCustomerText, reply, documents, msgId);
  //           } catch (_) { }
  //         } else if (currentEventType === 'error') {
  //           let errText = 'Bir hata oluştu.';
  //           try {
  //             const errData = JSON.parse(rawPayload.trim());
  //             errText = errData.message || errText;
  //           } catch (_) { }
  //           if (!streamMsgAdded) {
  //             addStreamMsg(errText, { isStreaming: false });
  //           } else {
  //             setMessages(prev =>
  //               prev.map(m => m.id === streamMsgId ? { ...m, text: errText, isStreaming: false } : m)
  //             );
  //           }
  //         }
  //       }
  //     }

  //     if (!streamMsgAdded) {
  //       setIsTyping(false);
  //       setMessages(prev => [...prev, {
  //         id: streamMsgId,
  //         sender: 'agent',
  //         text: 'Bir hata oluştu.',
  //         time: nowHHmm(),
  //         documents: [],
  //         msgId: null
  //       }]);
  //     }
  //   } catch (ex) {
  //     setMessages(prev => {
  //       const has = prev.some(m => m.id === streamMsgId);
  //       if (has) {
  //         return prev.map(m =>
  //           m.id === streamMsgId ? { ...m, text: ex?.message || 'Bir hata oluştu.' } : m
  //         );
  //       }
  //       return [...prev, {
  //         id: Date.now() + '_err',
  //         sender: 'agent',
  //         text: ex?.message || 'Bir hata oluştu.',
  //         time: nowHHmm(),
  //         documents: [],
  //         msgId: null
  //       }];
  //     });
  //   } finally {
  //     setIsTyping(false);
  //   }
  // }, [tasks, fisNo, input, KulModelKoduAciklama, convId, KUL_MODEL_KODU, user, isValidateReceipt, saveConversation, refreshTokenIfNeeded]);

  useEffect(() => {
    if (!open) {
      return;
    }
    const tokenRaw = localStorage.getItem("tk_token_info");
    if (!tokenRaw || isTokenAboutToExpire()) {
      getNewToken();
    }
  }, [open, fisNo]);

  useEffect(() => {
    const hasStreamingMsg = messages.some(m => m.isStreaming);
    if (hasStreamingMsg) {
      // Stream sırasında auto-scroll yok, ama buton ve ref durumunu güncelle
      const el = contentRef.current;
      if (el) {
        const threshold = 80;
        const atBottom = el.scrollHeight - el.scrollTop - el.clientHeight < threshold;
        isNearBottomRef.current = atBottom; // içerik büyüdükçe konumu takip et
        setShowScrollBtn(!atBottom);
      }
      return;
    }
    if (isNearBottomRef.current && contentRef.current) {
      programmaticScrollRef.current = true;
      const el = contentRef.current;
      el.scrollTop = el.scrollHeight;
      setShowScrollBtn(false); // programatik scroll'da butonu gizle
    }
  }, [messages, isTyping, open, fisNo]);

  useEffect(() => {
    const el = contentRef.current;
    if (!el) return;
    const handleScroll = () => {
      const threshold = 80;
      const atBottom = el.scrollHeight - el.scrollTop - el.clientHeight < threshold;
      if (programmaticScrollRef.current) {
        if (atBottom) programmaticScrollRef.current = false;
        return;
      }
      isNearBottomRef.current = atBottom;
      setShowScrollBtn(!atBottom);
    };
    el.addEventListener('scroll', handleScroll);
    return () => el.removeEventListener('scroll', handleScroll);
  }, [open]);

  useEffect(() => {
    // Sadece Dialog açıkken, fisNo varken ve mesaj listesi henüz boşken çalışır
    if (open && fisNo && messages.length === 0) {
      const conv = getConversationByFisNo(fisNo);
      if (conv) {
        setConvId(conv.conv_id);

        const storedQuick = getQuickQuestions(fisNo);

        const mapped = conv.KonusmaGecmisi.flatMap((msg, i) => {
          const soru = (msg.soru ?? '').trim();

          if (!soru) {
            return [
              {
                id: i + '_a',
                sender: 'agent',
                text: msg.cevap,
                time: formatTime(msg.tarih),
                documents: msg.documents || [],
                quickQuestions: i === 0 ? (storedQuick || []) : [],
                msgId: msg.msgId || null
              }
            ];
          }

          return [
            {
              id: i + '_c',
              sender: 'customer',
              text: msg.soru,
              time: formatTime(msg.tarih)
            },
            {
              id: i + '_a',
              sender: 'agent',
              text: msg.cevap,
              time: formatTime(msg.tarih),
              documents: msg.documents || [],
              quickQuestions: i === 0 ? (storedQuick || []) : [],
              msgId: msg.msgId || null
            }
          ];
        });

        setMessages(mapped);
      } else {
        const storedQuick = getQuickQuestions(fisNo);

        const aMsg = {
          id: WELCOME_MSG_ID,
          sender: 'agent',
          text:
            (user?.FirstName || "Teknisyen") +
            " merhaba, ben senin yapay zeka asistanınım. Bu ürünle ilgili dersime çalıştım. Karşılaştığın sorun ile ilgili bana her tür soruyu sorabilirsin.",
          time: nowHHmm(),
          documents: [],
          quickQuestions: storedQuick || []
        };
        setMessages([aMsg]); // prev => [...prev] yerine doğrudan seti güncelleyerek garantiye alıyoruz
        setConvId(null);

        saveConversation(
          fisNo,
          null,
          null,
          (user?.FirstName || "Teknisyen") +
          " merhaba, ben senin yapay zeka asistanınım. Bu ürünle ilgili dersime çalıştım. Karşılaştığın sorun ile ilgili bana her tür soruyu sorabilirsin.",
          []
        );

        if (!storedQuick || storedQuick.length === 0) {
          handleGetQuickQuestions();
        }
      }
    }
  }, [open, fisNo, getConversationByFisNo, messages.length, saveConversation, user.FirstName]); // messages.length takibi eklendi

  useEffect(() => {
    if (!pendingQuickSend) return;
    if (!input.trim()) return;

    handleSend();
    setPendingQuickSend(false);
  }, [pendingQuickSend, handleSend, input]);

  useEffect(() => {
    if (!quickQuestionsData || quickQuestionsData.length === 0) return;

    setMessages(prev =>
      prev.map(m =>
        m.id === WELCOME_MSG_ID
          ? { ...m, quickQuestions: quickQuestionsData }
          : m
      )
    );

    saveQuickQuestions(fisNo, quickQuestionsData);

  }, [quickQuestionsData, fisNo]);


  const handleGetQuickQuestions = () => {
    axios.get('GetTeknisyenKocuQuickQuestions')
      .then((response) => {
        const data = response.data.map(x => x.USER_QUESTION);
        setQuickQuestionsData(data);
      })
      .catch((ex) => {
        logger.error(ex)
      });

  }

  const saveQuickQuestions = (fisNo, questions) => {
    if (!fisNo || !Array.isArray(questions)) return;

    const all = JSON.parse(localStorage.getItem('quickQuestionsByFis') || '{}');

    all[String(fisNo)] = questions;

    try {
      localStorage.setItem(
        'quickQuestionsByFis',
        JSON.stringify(all)
      );
    } catch (e) {
      localStorage.removeItem('quickQuestionsByFis');
    }

  };







  const clearConversation = no => {
    const allConvs = getAllConversations();
    const updated = allConvs.filter(c => String(c.FisNo) !== String(no));

    try {
      localStorage.setItem(
        'conversations',
        JSON.stringify(updated)
      );
    } catch (e) {
      localStorage.removeItem('conversations');
    }


    setMessages([]);
    setConvId(null);

    const storedQuick = getQuickQuestions(no);

    const aMsg = {
      id: WELCOME_MSG_ID,
      sender: 'agent',
      text:
        (user?.FirstName || "Teknisyen") +
        " merhaba, ben senin yapay zeka asistanınım. Bu ürünle ilgili dersime çalıştım. Karşılaştığın sorun ile ilgili bana her tür soruyu sorabilirsin.",
      time: nowHHmm(),
      documents: [],
      quickQuestions: (storedQuick && storedQuick.length > 0)
        ? storedQuick
        : (quickQuestionsData || [])
    };

    setMessages([aMsg]);
    setConvId(null);

    if ((!storedQuick || storedQuick.length === 0) && (!quickQuestionsData || quickQuestionsData.length === 0)) {
      handleGetQuickQuestions();
    }
  };



  const handleDownloadDocument = (bankNo, pageNo, documentName) => {
    setDocumentLoading(`${bankNo}-${pageNo}`);
    axios
      .get(`/GetTeknisyenKocuRelatedDocument/${bankNo}`)
      .then(response => {
        const base64Data = response.data;

        const byteCharacters = atob(base64Data);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);

        const blob = new Blob([byteArray], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = documentName;
        document.body.appendChild(a);
        a.click();

        // Temizlik
        setDocumentLoading(null);
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      })
      .catch(error => {
        setDocumentLoading(null);
        logger.error('Döküman açılırken hata oluştu:', error);
      });
  };

  function convertMarkdown(md) {
    if (!md) return "";
    md = md.replace(/\\n/g, "\n");  // literal \n → gerçek newline
    md = md.replace(/^\s+|\s+$/g, "");

    const applyInline = t =>
      t.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");

    const lines = md.split("\n");
    let html = "";
    let listOpen = false;
    let subListOpen = false;

    const closeSubList = () => {
      if (subListOpen) { html += "</ul>"; subListOpen = false; }
    };
    const closeList = () => {
      closeSubList();
      if (listOpen) { html += "</ul>"; listOpen = false; }
    };

    for (const line of lines) {
      // Yatay çizgi → atla
      if (/^\s*-{3,}\s*$/.test(line)) continue;

      // Boş satır → listeleri kapat, küçük boşluk
      if (!line.trim()) {
        closeList();
        html += '<div style="height:4px"></div>';
        continue;
      }

      // Markdown başlıkları: # ## ### ####
      const hMatch = line.match(/^\s*(#{1,4})\s*(.+)$/);
      if (hMatch) {
        closeList();
        const sizes = { 1: '1.45rem', 2: '1.35rem', 3: '1.25rem', 4: '1.15rem' };
        html += `<p style="margin:10px 0 3px;font-size:${sizes[hMatch[1].length]};font-weight:700;color:#111">${applyInline(hMatch[2])}</p>`;
        continue;
      }

      // Numaralı başlık: "1. Başlık"
      const numMatch = line.match(/^(\d+)\.\s+(.+)$/);
      if (numMatch) {
        closeList();
        html += `<p style="margin:8px 0 2px;font-size:1.05rem;font-weight:700;color:#111">${numMatch[1]}. ${applyInline(numMatch[2])}</p>`;
        continue;
      }

      // Alt madde: " - metin" (girintili tire)
      const subMatch = line.match(/^ +- (.+)$/);
      if (subMatch) {
        if (!listOpen) { html += '<ul style="margin:2px 0;padding-left:8px;list-style:none">'; listOpen = true; }
        if (!subListOpen) { html += '<ul style="margin:0;padding-left:16px;list-style:none">'; subListOpen = true; }
        html += `<li style="margin:1px 0;color:#555;font-size:0.87rem">– ${applyInline(subMatch[1])}</li>`;
        continue;
      }

      // Ana madde: "- metin"
      const bulletMatch = line.match(/^- (.+)$/);
      if (bulletMatch) {
        closeSubList();
        if (!listOpen) { html += '<ul style="margin:2px 0;padding-left:8px;list-style:none">'; listOpen = true; }
        html += `<li style="margin:3px 0">– ${applyInline(bulletMatch[1])}</li>`;
        continue;
      }

      // Normal metin
      closeList();
      html += `<p style="margin:2px 0">${applyInline(line)}</p>`;
    }

    closeList();
    return html;
  }

  const handleFeedbackClick = (msgId, type) => {
    if (feedbackData.msgId === msgId && feedbackData.type === type) {
      // Aynı butona tekrar tıklandıysa seçimi kaldır
      setFeedbackData({ msgId: null, type: null, comment: '' });
    } else {
      // Yeni feedback seçimi
      setFeedbackData({ msgId, type, comment: '' });
    }
  };

  const handleSendFeedback = () => {
    if (!feedbackData.comment.trim()) return;

    const answerMsg = messages.find(msg => msg.id === feedbackData.msgId);
    const answerIndex = messages.findIndex(msg => msg.id === feedbackData.msgId);
    const questionMsg = answerIndex > 0
      ? [...messages]
        .slice(0, answerIndex)
        .reverse()
        .find(msg => msg.sender === 'customer')
      : null;

    const filteredQuestionText = questionMsg ? questionMsg.text.replace(/\n\(Ürün:.*\)$/, '').trim() : '';

    const data = {
      MsgId: answerMsg?.msgId || null,
      Answer: answerMsg?.text || '',
      Question: filteredQuestionText || '',
      IsLiked: feedbackData.type === 'like' ? 1 : 0,
      FeedbackComment: feedbackData.comment,
      ApplicationId: 2,
    };

    axios
      .post('/SetTeknisyenKocuFeedbackSend', data)
      .then((response) => {
        if (response.data && response.data.ErrorCode === '0') {
          setFeedbackData({ msgId: null, type: null, comment: '' });
          setSnackbar({ open: true, message: 'Geri bildiriminiz başarıyla kaydedildi.', severity: 'success' });
        } else {
          setSnackbar({ open: true, message: response.data?.ErrorDescription || 'Geri bildirim gönderilemedi.', severity: 'error' });
        }
      })
      .catch(ex => {
        setSnackbar({ open: true, message: 'Geri bildirim gönderilirken hata oluştu.', severity: 'error' });
      });
  };

  const getNewToken = () => {
    setIsTokenLoading(true);
    axios.get('/TeknisyenKocuLogin')
      .then((response) => {
        const data = response.data;
        const tokenInfo = {
          accessToken: data.access_token,
          tokenType: data.token_type,
          expiresAt: Date.now() + data.expires_in * 1000
        };


        try {
          localStorage.setItem(
            'tk_token_info',
            JSON.stringify(tokenInfo)
          );
        } catch (e) {
          localStorage.removeItem('tk_token_info');
        }


        setIsTokenLoading(false);
      }).catch((error) => {
        setIsTokenLoading(false);
        logger.error("Hata detayı:", error.message);
      });
  }

  return (
    <Dialog
      open={open}
      maxWidth="md"
      fullWidth
      onClose={() => {
        onClose();
      }}
      fullScreen={fullScreen}
      aria-modal="true"
    >
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box display="flex" alignItems="center">
            <Avatar style={{ backgroundColor: 'rgba(255, 152, 0, 0.1)', color: '#FF9800', width: 40, height: 40, marginRight: 12 }}>
              <ContactSupportIcon />
            </Avatar>
            <Box>
              <Typography variant="subtitle1" style={{ fontWeight: 'bold', lineHeight: 1.2 }}>
                Teknisyen Koçu
              </Typography>
              <Typography variant="caption" color="textSecondary" style={{ display: 'flex', alignItems: 'center' }}>
                <span style={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: '#4caf50', marginRight: 4, display: 'inline-block' }} />
                Çevrimiçi
              </Typography>
            </Box>
          </Box>
          <IconButton onClick={(e) => {
            e.stopPropagation(); // Tıklama olayının aşağıya/arkaya geçmesini engeller
            onClose();
          }}
            size="small" style={{ color: '#757575' }}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <Divider />
      <DialogContent className={classes.dialogContent} ref={contentRef}>
        <Box style={{ width: '100%', marginTop: 8 }} />
        {messages.map(m => {
          const isAgent = m.sender === 'agent';
          const isCustomer = m.sender === 'customer';
          return (
            <div
              key={m.id}
              className={`${classes.messageRow} ${isCustomer ? classes.messageRowCustomer : classes.messageRowAgent}`}
            >
              {isAgent && (
                <Avatar style={{ width: 32, height: 32, backgroundColor: '#009688', fontSize: '1rem', marginTop: 0 }}>
                  <ContactSupportIcon style={{ fontSize: '1rem' }} />
                </Avatar>
              )}
              <div className={classes.bubbleContainer}>
                <Paper
                  elevation={0}
                  className={`${classes.bubble} ${isAgent ? classes.bubbleAgent : classes.bubbleCustomer}`}
                >
                  <Typography
                    variant="body1"
                    component="div"
                    style={{ wordBreak: 'break-word', fontSize: '0.90rem', lineHeight: 1.5, textAlign: 'justify' }}
                  >
                    <span dangerouslySetInnerHTML={{ __html: convertMarkdown(m.text) }} />
                  </Typography>
                  {isAgent && m.quickQuestions?.length > 0 && (
                    <Box className={classes.quickWrap}>
                      {m.quickQuestions.map((q, idx) => (
                        <Chip
                          key={idx}
                          label={q}
                          clickable
                          className={classes.quickChip}
                          onClick={() => {
                            setInput(q);
                            setPendingQuickSend(true);
                          }}
                        />
                      ))}
                    </Box>
                  )}
                  {isAgent && m.documents && m.documents.length > 0 && (
                    <Box mt={1.5} display="flex" flexDirection="column">
                      <Typography variant="caption" style={{ fontWeight: 'bold', color: '#757575', marginBottom: 4 }}>
                        Bu bilgi için aşağıdaki dökümanlardan yararlanılmıştır:
                      </Typography>
                      {m.documents.map((doc, idx) => {
                        const isLoading = documentLoading === `${doc.BankNo}-${doc.PageNumber}`;
                        return (
                          <Paper
                            key={idx}
                            elevation={0}
                            className={classes.docPaper}
                            onClick={() => handleDownloadDocument(doc.BankNo, doc.PageNumber, doc.DocumentName)}
                          >
                            {isLoading ? (
                              <CircularProgress size={14} style={{ marginRight: 8, color: '#f44336' }} />
                            ) : (
                              <DescriptionIcon style={{ fontSize: 18, color: '#f44336', marginRight: 8 }} />
                            )}
                            <Typography variant="caption" style={{ maxWidth: 180, fontWeight: 500 }}>
                              {doc.DocumentDescription || doc.DocumentName}
                            </Typography>
                          </Paper>
                        );
                      })}
                    </Box>
                  )}
                  <Typography variant="caption" className={classes.timeText} style={{ color: 'rgba(18, 17, 17, 0.9)' }}>
                    {m.time}
                  </Typography>
                  {/* Feedback Area */}
                  {isAgent && (
                    <>
                      <Divider style={{ marginTop: 8, marginBottom: 8, borderColor: '#e0e0e0' }} />
                      <Box display="flex" flexDirection="column" style={{ gap: 8 }}>
                        <Box display="flex" justifyContent="flex-end" style={{ gap: 4 }}>
                          <IconButton
                            size="small"
                            onClick={() => handleFeedbackClick(m.id, 'like')}
                            style={{
                              padding: 4,
                            }}
                          >
                            <ThumbUpOutlinedIcon
                              style={{
                                color: feedbackData.msgId === m.id && feedbackData.type === 'like' ? '#4caf50' : '#9e9e9e',
                                fontSize: '1rem'
                              }}
                            />
                          </IconButton>

                          <IconButton
                            size="small"
                            onClick={() => handleFeedbackClick(m.id, 'dislike')}
                            style={{
                              padding: 4,
                            }}
                          >
                            <ThumbDownOutlinedIcon
                              style={{
                                color: feedbackData.msgId === m.id && feedbackData.type === 'dislike' ? '#f44336' : '#9e9e9e',
                                fontSize: '1rem'
                              }}
                            />
                          </IconButton>
                        </Box>

                        {feedbackData.msgId === m.id && (
                          <Box style={{ marginTop: 8 }}>
                            <TextField
                              fullWidth
                              size="small"
                              variant="outlined"
                              multiline
                              rows={2}
                              placeholder="Geri bildiriminizi yazınız..."
                              value={feedbackData.comment}
                              onChange={(e) => setFeedbackData({ ...feedbackData, comment: e.target.value })}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <IconButton
                                      onClick={handleSendFeedback}
                                      disabled={!feedbackData.comment.trim()}
                                      size="small"
                                      style={{
                                        color: feedbackData.comment.trim() ? '#FF9800' : '#bdbdbd'
                                      }}
                                    >
                                      <SendIcon fontSize="small" />
                                    </IconButton>
                                  </InputAdornment>
                                )
                              }}
                              style={{
                                backgroundColor: '#fff',
                                fontSize: '0.85rem'
                              }}
                            />
                          </Box>
                        )}
                      </Box>
                    </>
                  )}
                </Paper>
              </div>
              {isCustomer && (
                <Avatar style={{ width: 32, height: 32, backgroundColor: '#FF9800', fontSize: '1rem', marginTop: 0, marginRight: 0 }}>
                  <PersonIcon style={{ fontSize: '1rem' }} />
                </Avatar>
              )}
            </div>
          );
        })}
        {isTyping && (
          <div className={`${classes.messageRow} ${classes.messageRowAgent}`}>
            <Avatar style={{ width: 32, height: 32, backgroundColor: '#009688', marginTop: 0 }}>
              <ContactSupportIcon style={{ fontSize: '1rem' }} />
            </Avatar>
            <Paper
              elevation={0}
              className={`${classes.bubble} ${classes.bubbleAgent}`}
              style={{
                backgroundColor: '#ffffff',
                borderRadius: '0px 12px 12px 12px',
                marginLeft: 8,
                padding: 12
              }}
            >
              <div style={{
                position: 'absolute', top: 0, left: '-9px',
                width: 0, height: 0,
                borderTop: '10px solid #ffffff', borderLeft: '10px solid transparent'
              }} />
              <TypingIndicator />
            </Paper>
          </div>
        )}
        {showScrollBtn && (
          <IconButton
            className={classes.scrollToBottomBtn}
            onClick={() => {
              isNearBottomRef.current = true;
              setShowScrollBtn(false);
              if (endRef.current) {
                endRef.current.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            size="small"
          >
            <KeyboardArrowDownIcon />
          </IconButton>
        )}
        <div ref={endRef} />
      </DialogContent>
      <Divider />
      <DialogActions style={{ padding: '10px 12px', backgroundColor: '#fff' }}>
        <Box display="flex" alignItems="center" width="100%" style={{ gap: 8 }}>
          <Tooltip title="Yeni Sohbet Başlat">
            <IconButton
              onClick={() => clearConversation(fisNo)}
              style={{
                width: 40,
                height: 40,
                backgroundColor: '#fff0f0',
                border: '1.5px solid #ffcccc',
                borderRadius: 12,
                flexShrink: 0,
                padding: 0,
                marginBottom: 0,
              }}
            >
              <DeleteSweepIcon style={{ color: '#e53935', fontSize: 20 }} />
            </IconButton>
          </Tooltip>

          {/* Giriş Alanı Kapsülü */}
          <div className={classes.inputCapsule}>
            <TextField
              placeholder="Mesajınızı yazın..."
              fullWidth
              multiline
              minRows={2}
              maxRows={4}
              value={input}
              onChange={e => setInput(e.target.value)}
              onKeyDown={e => {
                if (e.key === 'Enter' && !e.shiftKey) {
                  e.preventDefault();
                  handleSend();
                }
              }}
              InputProps={{
                disableUnderline: true,
                style: { fontSize: '0.9rem', lineHeight: 1.5 }
              }}
            />

            <IconButton
              style={{
                width: 36,
                height: 36,
                borderRadius: 10,
                flexShrink: 0,
                backgroundColor: input.trim() ? '#FF9800' : '#e0e0e0',
                color: '#fff',
                transition: 'background-color 0.2s',
                padding: 0,
              }}
              onClick={handleSend}
              disabled={isTokenLoading || !input.trim()}
            >
              {isTokenLoading ? (
                <CircularProgress size={18} style={{ color: '#fff' }} />
              ) : (
                <SendIcon style={{ fontSize: 18 }} />
              )}
            </IconButton>
          </div>
        </Box>
      </DialogActions>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          variant="filled"
          style={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Dialog>
  );
}

const mapStateToProps = (state) => ({
  tasks: state.tasks1
});

export default connect(mapStateToProps)(TeknisyenKocuDialog);